import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

type IconType = typeof IconType[keyof typeof IconType];

const IconType = {
  PluginCloudGroup: 'plugin-cloud-group',
  CloudGroup: 'cloud-group',
  PluginGroup: 'plugin-group',
} as const;

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateComponent {
  @Output()
  mainActionClick = new EventEmitter();

  @Input()
  mainDescriptionText: string;

  @Input()
  secondaryDescriptionText: string;

  @Input()
  mainButtonText: string;

  @Input()
  includePlugins: boolean;

  @Input()
  iconType: IconType;

  @Input()
  mainButtonIcon: string;

  get leftIcon(): string {
    switch (this.iconType) {
      case IconType.PluginCloudGroup:
        return 'plugins/plugin-cloud-group1';
      case IconType.CloudGroup:
        return 'cloud-group1';
      case IconType.PluginGroup:
        return 'plugin-group1';
    }
  }

  get rightIcon(): string {
    switch (this.iconType) {
      case IconType.PluginCloudGroup:
        return 'plugins/plugin-cloud-group2';
      case IconType.CloudGroup:
        return 'cloud-group2';
      case IconType.PluginGroup:
        return 'plugin-group2';
    }
  }
}
